import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

@Directive({ selector: 'img[appImgPreview]' })

export class ImagePreviewDirective implements OnChanges {

  @Input() image: any;

  constructor(private el: ElementRef) { }

  ngOnChanges() {

    const reader = new FileReader();
    const el = this.el;

    reader.onloadend = (e) => {
      el.nativeElement.src = reader.result;
    };

    if (this.image) {
      return reader.readAsDataURL(this.image);
    }
  }
}
